import axios from 'axios';

const api = axios.create({
    baseURL: '/api/v1',
    withCredentials: true,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((config) => {
    const token = document.head.querySelector('meta[name="csrf-token"]');
    if (token) config.headers['X-CSRF-TOKEN'] = token.content;
    return config;
});

api.interceptors.response.use(
    (response) => {
        if (response.data && typeof response.data.success === 'boolean') {
            response.data = response.data.data;
        }
        return response;
    },
    (error) => {
        if (error.response?.status === 401) {
            window.dispatchEvent(new CustomEvent('session:expired'));
        }
        return Promise.reject(error);
    },
);

export default api;
